import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	deselectCheckboxLabelOld: {
		id: 'backlog.card-list.cardlist-checkbox.deselect-checkbox-label-old',
		defaultMessage: 'Deselect all issues in sprint',
		description: 'The label for the card list checkbox when checkbox is checked',
	},
	selectCheckboxLabelOld: {
		id: 'backlog.card-list.cardlist-checkbox.select-checkbox-label-old',
		defaultMessage: 'Select all issues in sprint',
		description:
			'The label for the card list checkbox when checkbox is unchecked or indeterminate.',
	},
	deselectCheckboxLabel: {
		id: 'backlog.card-list.cardlist-checkbox.deselect-checkbox-label',
		defaultMessage: 'Deselect all issues in {listName}',
		description: 'The label for the card list checkbox when checkbox is checked',
	},
	selectCheckboxLabel: {
		id: 'backlog.card-list.cardlist-checkbox.select-checkbox-label',
		defaultMessage: 'Select all issues in {listName}',
		description:
			'The label for the card list checkbox when checkbox is unchecked or indeterminate.',
	},
	selectCheckboxLabelIssueTermRefresh: {
		id: 'backlog.card-list.cardlist-checkbox.select-checkbox-label-issue-term-refresh',
		defaultMessage: 'Select all issues in {listName}',
		description:
			'The label for the card list checkbox when checkbox is unchecked or indeterminate.',
	},
	deselectCheckboxLabelIssueTermRefresh: {
		id: 'backlog.card-list.cardlist-checkbox.deselect-checkbox-label-issue-term-refresh',
		defaultMessage: 'Deselect all issues in {listName}',
		description: 'The label for the card list checkbox when checkbox is checked',
	},
	deselectCheckboxLabelOldIssueTermRefresh: {
		id: 'backlog.card-list.cardlist-checkbox.deselect-checkbox-label-old-issue-term-refresh',
		defaultMessage: 'Deselect all issues in sprint',
		description: 'The label for the card list checkbox when checkbox is checked',
	},
	selectCheckboxLabelOldIssueTermRefresh: {
		id: 'backlog.card-list.cardlist-checkbox.select-checkbox-label-old-issue-term-refresh',
		defaultMessage: 'Select all issues in sprint',
		description:
			'The label for the card list checkbox when checkbox is unchecked or indeterminate.',
	},
});
